/**
 * #1535 — Map a Notification's `entityType` / `entityId` to an in-app
 * route. Centralised so the bell dropdown (Header.tsx) and the new
 * /notifications page row-click handler resolve deep-links the same way.
 *
 * Returns `null` when no known route resolves — the caller falls back
 * to an in-place read-only drawer/modal showing the full body.
 */

const ENTITY_ROUTE_MAP: Record<string, (id: string) => string> = {
  // #1887 — `/loads/:id` is the module resolver route (LoadRedirect): it looks
  // up the load's moduleVariant and redirects to the correct module form.
  Load: (id) => `/loads/${id}`,
  LoadStop: (id) => `/loads/${id}`,
  SupportTicket: () => `/support`,
  Customer: (id) => `/customers/${id}`,
  Driver: (id) => `/drivers/${id}`,
  Equipment: (id) => `/equipment/${id}`,
  Location: (id) => `/locations/${id}`,
  Invoice: () => `/invoices`,
  Settlement: () => `/settlements`,
  UspsContract: () => `/usps/contracts`,
};

export function resolveNotificationRoute(
  entityType: string | null | undefined,
  entityId: string | null | undefined,
): string | null {
  if (!entityType) return null;
  const resolver = ENTITY_ROUTE_MAP[entityType];
  if (!resolver) return null;
  return resolver(entityId ?? '');
}
